module.exports = __webpack_public_path__ + "static/media/lavieenrose.17086e89.jpg";